import type { StoreApi } from 'zustand/vanilla';
import { createStore } from 'zustand/vanilla';

interface QosNavigationState {
  readonly pathname: string | undefined;
  readonly setPathname: (pathname: string) => void;
}

export const qosNavigationStore: StoreApi<QosNavigationState> = createStore<QosNavigationState>((set) => ({
  pathname: undefined,
  setPathname: (pathname: string) => {
    set({ pathname });
  },
}));

export const setQosNavigationPathname = (pathname: string): void => {
  qosNavigationStore.getState().setPathname(pathname);
};

export const subscribeToQosNavigationPathname = (listener: (pathname: string) => void): (() => void) =>
  // Returns an unsubscribe function; the caller owns teardown and should invoke it to stop listening.
  qosNavigationStore.subscribe((state, previousState) => {
    if (state.pathname !== previousState.pathname && state.pathname !== undefined) {
      listener(state.pathname);
    }
  });
